import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#000",
  d: "M34.142 34.142c-7.81 7.81-20.474 7.81-28.284 0-7.81-7.81-7.81-20.474 0-28.284 7.81-7.81 19.244-6.58 27.054 1.23 7.81 7.81 9.04 19.244 1.23 27.054Z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#A2001D",
  d: "M5.858 5.858c7.81-7.81 20.474-7.81 28.284 0 7.81 7.81 7.81 20.474 0 28.284"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "m15.284 26.957.324.996h1.048l-.848.616.324.996-.848-.616-.847.616.324-.996-.848-.616h1.048l.323-.996Zm-2.675-9.566.54 1.661h1.746l-1.413 1.026.54 1.661-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66Zm0 12.174.54 1.661h1.746l-1.413 1.026.54 1.661-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66Zm5.105-7.825.54 1.66H20l-1.413 1.026.54 1.661-1.413-1.026-1.412 1.026.54-1.66-1.414-1.027h1.747l.54-1.66Zm-10.211 0 .54 1.66h1.746l-1.413 1.026.54 1.661-1.413-1.026-1.413 1.026.54-1.66L5.217 23.4h1.746l.54-1.66Z"
}, null, -1), a = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M33.48 14.81a5.178 5.178 0 0 0-3.303-1.513l3.736-2.906a6.939 6.939 0 0 0-5.428-2.018 5.192 5.192 0 0 0-1.335-2.286L25.674 9.04a2.174 2.174 0 1 0-2.951 2.951l-2.952 1.476a5.192 5.192 0 0 0 2.287 1.336 6.936 6.936 0 0 0 2.017 5.427l3.264-4.196c.246-.242.57-.376.915-.376.348 0 .676.136.922.382.247.247.383.574.383.923 0 .348-.136.676-.383.922l1.23 1.23c.575-.575.892-1.34.892-2.152 0-.665-.213-1.298-.604-1.82.57.152 1.11.45 1.557.897a3.482 3.482 0 0 1 0 4.92l1.23 1.23a5.183 5.183 0 0 0 1.528-3.69 5.185 5.185 0 0 0-1.529-3.69Z"
}, null, -1), s = [
  n,
  h,
  c,
  a
];
function i(d, _) {
  return t(), e("svg", o, [...s]);
}
const m = { render: i };
export {
  m as default,
  i as render
};
